import { useCallback } from 'react';
import type { ClarityWindow } from '../components/app/MicrosoftClarity';

const useTrackEvent = () => {
  const clarityWindow = window as ClarityWindow;

  const trackEvent = useCallback((eventName: string) => {
    if (clarityWindow.clarity) {
      clarityWindow.clarity('event', eventName);
    }
  }, []);

  return trackEvent;
};

export default useTrackEvent;
